export default {
  header: 'Meidän täytyy vahvistaa puhelinnumerosi',
  buttons: {
    confirm: 'Vahvista',
  },
  toasts: {
    invalid_code: 'Virheellinen koodi. Yritä uudelleen.',
  },
};
